import { UPDATE_USER } from "../actionTypes";

const INITIAL_STATE = {
  token: "",
  email: "",
  id: "",
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_USER:
      return action.user;
    default:
      return state;
  }
};

export default reducer;
